<template>
    <div class="card shadow">
        <slot />
        <div class="card-body">
            <h5 class="card-title">{{ title }}</h5>
            <p class="card-text">{{ text }}</p>
            <a :href="`${href}`" class="btn btn-primary">{{ buttonText }}</a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CardContainer',
    props: {
        title: String,
        text: String,
        buttonText: String,
        href: String,
    },
}
</script>

<style lang="scss" scoped>

</style>